import { saveAs } from 'file-saver';
import { pdf } from '@react-pdf/renderer';
import ReportExportPDF from '.';
import { DataBlock, DataBlockChunk } from './InputData';

const exportPDF = async (generateFileName, [headings, tableData]) => {
  const pdfDoc = (
    <ReportExportPDF
      reportName="Status Report"
      dataBlocks={[]}
      tableData={{
        headings,
        tableData
      }}
    />
  );

  const asPdf = pdf([]);
  asPdf.updateContainer(pdfDoc);
  const fileName = generateFileName();
  const blob = await asPdf.toBlob();
  saveAs(blob, `${fileName}.pdf`);
};

export default exportPDF;
